<template>
<q-page class="main">
  <q-card class="page-card">
    <q-card-section class="page-card__main-content">
      <div
          class="row items-center justify-between q-gutter-y-lg"
          :class="{ 'q-mb-lg': $isDesktop }"
      >
        <h1 class="heading-2">
          Kaart inladen
        </h1>
      </div>
      <div>
        <MapImport :mapgroups="mapGroups"
        />
      </div>
    </q-card-section>
  </q-card>
</q-page>
</template>

<script>
import MapImport from './import/MapImport.vue'

export default {
  components: {
    MapImport,
  },
  props: {
    mapGroups: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

